exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rate-limit-container[data-v-1092e6e8] {\n  padding-top: 8px;\n}\n.rule-tip[data-v-1092e6e8] {\n  margin-bottom: 12px;\n}\n.rule-content p[data-v-1092e6e8] {\n  margin: 2px 0;\n  line-height: 1.6;\n}\n.search-form[data-v-1092e6e8] {\n  margin-bottom: 12px;\n}\n.form-tip[data-v-1092e6e8] {\n  margin-left: 8px;\n  color: #999;\n  font-size: 12px;\n}\n", ""]);

// exports
